<template>
  <div class="footprint">
    <div v-for="(map, index) in list" :key="index">
      <div class="year-month">
        <div class="month">{{map.month}}月</div>
        <div class="year">{{map.year}}</div>
      </div>
      <div class="items">
        <div
          :class="(index + 1) % 5 ? 'item' : 'item item-last'"
          v-for="(item, index) in map.list"
          :key="index"
          @click="click(item)"
        >
          <img :src="util.getImageUrl(util.getHead(util.string2Array(item.image)), '140x140')" alt />
          <div class="name">{{item.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyFootprint",
  data() {
    return {
      targetName: "service",
      list: {}
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    async fetch() {
      this.list = await this.ajax.doPost({
        packageName: "user",
        className: "userHistory",
        methodName: "my",
        params: {}
      });
    },
    click(e) {
      switch (e.type) {
        case "product":
          window.open("/product/baike/" + e.id);
          break;
        case "service":
          window.open("/service/detail/" + e.id);
          break;
        case "ovop":
          window.open("/ovop/detail/" + e.id);
          break;
      }
    }
  }
};
</script>

<style lang="less">
.footprint {
}
</style>


<style lang="less" scoped>
.footprint {
  //   width: 100%;
  background: white;
  padding: 60px;
  .year-month {
    display: inline-block;
    vertical-align: top;
    margin-right: 20px;
    width: 140px;
    background: #ecfff2;
    color: #1b994f;
    height: 194px;
    text-align: center;
    border-radius: 10px;
    // line-height: 193px;

    .month {
      margin-top: 50px;
      font-size: 40px;
    }

    .year {
      font-size: 24px;
    }
  }
  .items {
    display: inline-block;
    width: 800px;
  }
  .item {
    display: inline-block;

    text-align: center;

    width: 140px;

    margin-right: 20px;
    margin-bottom: 20px;

    cursor: pointer;

    background: #f7faf8;

    border-radius: 10px;

    img {
      border-radius: 10px 10px 0 0;
      width: 100%;
      height: 100%;
    }

    .name {
      margin: 5px;
      height: 40px;
      font-size: 14px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 20px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;

      text-align: center;
    }

    .features {
      font-size: 12px;
      font-weight: 400;
      color: rgba(109, 114, 120, 1);
      line-height: 17px;

      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      height: 34px;
    }
  }
  .item-last {
    margin-right: 0;
  }
}
</style>

